const scrollbar = document.querySelector('.custom-scrollbar-container');
const scrollElement = scrollbar.querySelector('.product-series-series');

document.addEventListener('DOMContentLoaded', function () {
  const scrollbarTrack = document.createElement('div');
  scrollbarTrack.classList.add('scrollbar-track');

  const scrollbarThumb = document.createElement('div');
  scrollbarThumb.classList.add('scrollbar-thumb');

  scrollbar.appendChild(scrollbarTrack);
  scrollbarTrack.appendChild(scrollbarThumb);

  scrollElement.addEventListener('scroll', function () {
    const scrollPercentage = (scrollElement.scrollLeft / (scrollElement.scrollWidth - scrollbar.clientWidth)) * 70;
    const thumbPosition = scrollPercentage + '%';

    if (window.innerWidth > 460 && window.innerWidth < 768) {
      scrollbarThumb.style.width = '27%';
    } else {
      scrollbarThumb.style.width = (scrollElement.clientWidth / scrollElement.scrollWidth) * 100 + '%';
    }

    scrollbarThumb.style.left = thumbPosition;
  });
});

document.addEventListener('DOMContentLoaded', function () {
  let isDragging = false;
  let initialX = 0;
  let scrollLeft = 0;

  scrollElement.addEventListener('mousedown', function (e) {
    isDragging = true;
    initialX = e.clientX;
    scrollLeft = scrollElement.scrollLeft;

    scrollElement.style.userSelect = 'none';
  });

  document.addEventListener('mousemove', function (e) {
    if (!isDragging) return;

    let deltaX = e.clientX - initialX;
    scrollElement.scrollLeft = scrollLeft - deltaX;
  });

  document.addEventListener('mouseup', function () {
    isDragging = false;
    scrollElement.style.userSelect = 'auto';
  });
});
